import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import DocumentListItem from './DocumentListItem';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, x: -20 },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 24,
    },
  },
  exit: {
    opacity: 0,
    x: -20,
    transition: { duration: 0.2 },
  },
};

export default function DocumentsList({
  docs,
  isPreviewable,
  canManageDoc,
  openDetails,
  openPreview,
  openShare,
  openRename,
  openReupload,
  onDelete,
  formatFileSize,
  formatDate,
}) {
  if (!docs?.length) return null;

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="space-y-4"
    >
      <AnimatePresence mode="popLayout">
        {docs.map(doc => (
          <motion.div key={doc.id} layout variants={itemVariants} exit="exit">
            <DocumentListItem
              doc={doc}
              isPreviewable={isPreviewable}
              canManageDoc={canManageDoc}
              openDetails={openDetails}
              openPreview={openPreview}
              openShare={openShare}
              openRename={openRename}
              openReupload={openReupload}
              onDelete={onDelete}
              formatFileSize={formatFileSize}
              formatDate={formatDate}
            />
          </motion.div>
        ))}
      </AnimatePresence>
    </motion.div>
  );
}
